import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Autocomplete, Box, Button, Grid, Select, TextField, Tooltip, Typography } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useFormik } from "formik";
import * as yup from "yup";
import style from './patient.module.scss';
import { useEffect } from 'react';
import { Dropdown } from 'reactstrap';
import { useNavigate, useParams } from 'react-router';
import { PageRoutes } from '../../../constants';
import { toast } from 'react-toastify';
import { addLab, editLab, getByLabId, labAddDropdown, labDropdown } from '../../../Pages/Lab/LabServices';
import { CMLabel } from '../../../components/common/Form/FormLabels';
import { FlexDiv } from '../../../components/common/Flex/Flex';
import { buttonStyle } from '../../../components/common/Helpers/InlineStyles';
import { CMButton, CMLinkButton } from '../../../components/common/Button/Button';
import PatientModel from './PatientModal';
import { aadharRegex, floatingRegex, nameRegex, numberRegex, phoneRegex, wordToWordSpaceRegex } from '../../../components/common/Helpers/Validations';
import { addPatient, editPatient, getByPatientId } from '../PatientServices';
import { idText } from 'typescript';
import { CMAutoComplete } from '../../../components/common/AutoComplete/AutoComplete';



interface Column {
    id: 'id' | 'weight' | 'bp' | 'fever' | 'sp02' | 'first_visit' | 'revisit' | 'amount' | 'payment_date' | 'reason';
    label: string;
    minWidth?: number;
    align?: 'left';
    format?: (value: number) => string;
}

const columns: readonly Column[] = [
    {
        id: 'weight',
        label: 'Weight',
        minWidth: 170,
        align: 'left',
    },
    {
        id: 'bp',
        label: 'Blood Pressure(BP)',
        minWidth: 200,
        align: 'left',
    },
    {
        id: 'fever',
        label: 'Fever',
        minWidth: 170,
        align: 'left',
    },
    {
        id: 'sp02',
        label: 'SP02',
        minWidth: 170,
        align: 'left',
    },
    {
        id: 'first_visit',
        label: 'First Visit',
        minWidth: 170,
        align: 'left',
    },
    {
        id: 'revisit',
        label: 'Revisit',
        minWidth: 170,
        align: 'left',
    },
    {
        id: 'amount',
        label: 'Amount',
        minWidth: 170,
        align: 'left',
    },
    {
        id: 'payment_date',
        label: 'Payment Date',
        minWidth: 170,
        align: 'left',
    },
    {
        id: 'reason',
        label: 'Reason',
        minWidth: 170,
        align: 'left',
    },
];
interface Data {
    weight: string;
    bp: string;
    fever: string;
    first_visit: string;
    spo2: string;
    revisit: string;
    reason: string;
}
const PatientTable = (props: any) => {
    const data=[{id:1,label:"Male"},{id:2,label:"Female"},{id:3,label:"Others"}]
    const [openModal, setOpenModal] = React.useState(false);
    const [tableData, setTableData] = React.useState<any>([]);
    const [openEditModal, setOpenEditModal] = React.useState(false);
    const [SelectedRowData, setSelectedRowData] = React.useState<any>();
    const [index, setIndex] = React.useState<any>(null)
    const [patientName, setPatientName] = React.useState<any>([])
    const history = useNavigate();
    const { id } = useParams();
    const [test1,setTest1]=React.useState(data)

    useEffect(() => {

        if (id) {
            getByPatientId(id).then((res: any) => {
                console.log(res, "resres", props);
                setSelectedRowData(res);
                formik.setValues(res);
                setTableData(res.patient_details)

                if(res.father_or_mother_name==null){
                    formik.setFieldValue('father_or_mother_name', "")
                }
            
                if(res.contact_number==null){
                    formik.setFieldValue('contact_number', "")
                }

                if(res.aadhar_number==null){
                    formik.setFieldValue('aadhar_number', "")
                }

                if(res.height==null){
                    formik.setFieldValue('height', "")
                }

                if(res.age==null){
                    formik.setFieldValue('age', "")
                }

                if(res.address==null){
                    formik.setFieldValue('address', "")
                }
                
            })
        }

    }, []);

    
    const handleedit = (SelectedRowData:any) =>{
        console.log(SelectedRowData,"selectedRowData");
        const updatedTableData = [...tableData]; 
        const index = updatedTableData.findIndex((item) => item.id === SelectedRowData.id);
        console.log(index,"@@@@@@@@@@@@@@")
        if (index !== -1) {
            updatedTableData[index] = SelectedRowData;
            console.log(updatedTableData,"@@@@@@@@@@@@@@@@@@@@");
            setTableData(updatedTableData);
            const payload = {
                id: SelectedRowData.id, 
                newData: SelectedRowData
            };
            console.log('Payload to submit:', payload);

            tableData[index] = payload.newData;

        }
           
    }

    const handleShow = () => {
        setOpenModal(true);
    };

    const handleChange = (fields: any, e: any) => {
        formik.setFieldValue(fields, e.target.value)
        console.log(e.target.value)
    }

    const Edithandle = (rowData: any, index: any) => {
        console.log(rowData, 'rowwwwwwwwwwwwwwwwwwwwwwwww')
        setOpenEditModal(true);
        setSelectedRowData(rowData);
        setIndex(index)
    };



    // const handledit = (selectedRowData: any) => {
    //     console.log(selectedRowData, "SelectedRowData");

    //     if (selectedRowData?.id) selectedRowData.id = tableData.find((e: any) => e.id == selectedRowData.id); // Update the record at the found index
    //     tableData[index] = selectedRowData
    // }
    const handleDelete = (id: any) => {
        const updatedRecords = tableData.filter((v: any, i: any) => id !== i);
        setTableData(updatedRecords);
    };

    const handleClose = () => setOpenModal(false);
    const handleCloseedit = () => setOpenEditModal(false);
    const handleAddRow = (newRow: any) => {
        console.log(newRow, "newRownewRow");
        // if (typeof newRow?.lab_test_name == 'number') newRow.lab_test_name = labDrop?.find((e: any) => e.id == newRow.lab_test_name).label
        const updatedData = ([...tableData, newRow]);
        setTableData(updatedData);
        formik.setFieldValue('patient_details', updatedData)
        localStorage.setItem('patient', JSON.stringify(updatedData));
    }
    const handleDropdownChange = (fields: any, e: any) => {
        formik.setFieldValue(fields, e.label)
    }
    
    const formik: any = useFormik({
        initialValues: {
            contact_number: SelectedRowData?.contact_number ? SelectedRowData?.contact_number:"",
            gender: SelectedRowData?.gender ? SelectedRowData?.gender : '',
            name: SelectedRowData?.patient_name ? SelectedRowData?.patient_name : '',
            father_or_mother_name: SelectedRowData?.father_name ? SelectedRowData?.father_name:"",
            aadhar_number: SelectedRowData?.aadhar_number ? SelectedRowData?.aadhar_number:"",
            height: SelectedRowData?.height ?SelectedRowData?.height:"",
            age:SelectedRowData?.age ?SelectedRowData?.age:"",
            address:SelectedRowData?.address ?SelectedRowData?.address:"",
            patient_details: "",
        },
        validationSchema: yup.object({
            name: yup.string().ensure().required("Patient Name is required!").matches(nameRegex, { message: "Please enter only Alpha letters!" }).matches(wordToWordSpaceRegex, { message: "Please do not include leading spaces!" }).min(3, 'To short!'),
            contact_number: yup.string().min(10, 'Invalid Mobile Number').max(10, 'Invalid Mobile Number').matches(phoneRegex, { message: 'Enter Valid Contact Number', }),
            gender: yup.string().matches(nameRegex, { message: "Please enter only Alpha letters!" }),
            father_or_mother_name: yup.string().matches(nameRegex, { message: "Please enter only Alpha letters!" }).matches(wordToWordSpaceRegex, { message: "Please do not include leading spaces!" }).min(3, 'To short!'),
            aadhar_number: yup.string().matches(aadharRegex, { message: " Please Enter Only Valid Numbers!" }),
            height: yup.string().matches(floatingRegex, { message: "please enter only Numbers!" }),
            age: yup.string().matches(floatingRegex, { message: "please enter only Numbers!" }),
            address: yup.string().min(3, 'To short!'),
        }),
        onSubmit: (values: any) => {
            values.patient_details = tableData;
            console.log(values, 'Payload to ')
            if (id) {
                editPatient(values, id).then((res: any) => {
                    formik.setValues(res.patient_details)
                    toast.success("Record Updated Successfully")
                    history(PageRoutes.PATIENT_LIST);
                }, (error: any) => {
                    console.log(error)
                });
            } else {
                addPatient(values).then((res: any) => {
                    toast.success("Record Created Successfully")
                    history(PageRoutes.PATIENT_LIST);
                }, (error: any) => {
                    console.log(error)
                });
            }
        }
    });
    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={3} xs={12} sm={12} md={12} lg={12} rowSpacing={2}>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <CMLabel>Patient Name</CMLabel>
                        <TextField
                            placeholder='Enter Patient Name '
                            size="small"
                            name="name"
                            fullWidth
                            onChange={(e: any) => handleChange("name", e)}
                            value={formik.values?.name}
                        />
                        {formik.touched.name && formik.errors.name && (
                            <div className={style.laberrortext + " text-danger"}>{formik.errors.name}</div>)
                        }
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <CMLabel>Father / Mother / Spouse Name</CMLabel>
                        <TextField
                            placeholder='Enter Name '
                            size="small"
                            name="father_or_mother_name"
                            fullWidth
                            onChange={(e: any) => handleChange("father_or_mother_name", e)}
                            value={formik.values?.father_or_mother_name}
                        />
                        {/* {formik.touched.father_or_mother_name && formik.errors.father_or_mother_name && (
                            <div className={style.laberrortext + " text-danger"}>{formik.errors.father_or_mother_name}</div>)
                        } */}
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <CMLabel>Aadhar Number</CMLabel>
                        <TextField
                            placeholder='Enter Aadhar Number'
                            size="small"
                            name="aadhar_number"
                            fullWidth
                            onChange={(e: any) => handleChange("aadhar_number", e)}
                            value={formik.values?.aadhar_number}
                        />
                        {/* {formik.touched.aadhar_number && formik.errors.aadhar_number && (
                            <div className={style.laberrortext + " text-danger"}>{formik.errors.aadhar_number}</div>)
                        } */}
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <CMLabel>Gender</CMLabel>
                        <CMAutoComplete
                            placeholder='Enter gender'
                            options={test1}
                            disabled={false}
                            name="gender"
                            onChange={(e: any) => handleDropdownChange("gender", e)}
                            value={formik.values?.gender || ""}
                            errors={formik.touched.gender && Boolean(formik.errors.gender)}
                            helperText={formik.touched.gender && formik.errors.gender}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <CMLabel>Contact Number</CMLabel>
                        <TextField
                            placeholder='Enter Contact Number '
                            size="small"
                            name="contact_number"
                            fullWidth
                            onChange={(e: any) => handleChange("contact_number", e)}
                            value={formik.values?.contact_number}
                        />
                        {/* {formik.touched.contact_number && formik.errors.contact_number && (
                            <div className={style.laberrortext + " text-danger"}>{formik.errors.contact_number}</div>)
                        } */}
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <CMLabel>Height</CMLabel>
                        <TextField
                            placeholder='Enter Height '
                            size="small"
                            name="height"
                            fullWidth
                            onChange={(e: any) => handleChange("height", e)}
                            value={formik.values?.height}
                        />
                        {/* {formik.touched.height && formik.errors.height && (
                            <div className={style.laberrortext + " text-danger"}>{formik.errors.height}</div>)
                        } */}
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <CMLabel>Address</CMLabel>
                        <TextField
                            placeholder='Enter address '
                            size="small"
                            name="address"
                            multiline
                            minRows={3}
                            fullWidth
                            onChange={(e: any) => handleChange("address", e)}
                            value={formik.values?.address}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <CMLabel>Age</CMLabel>
                        <TextField
                            placeholder='Enter age '
                            size="small"
                            name="age"
                            fullWidth
                            onChange={(e: any) => handleChange("age", e)}
                            value={formik.values?.age}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ display: "flex", justifyContent: "flex-end", mt: 1, mb: 2 }} >
                            <Button variant='contained' value="ADD" color='primary' onClick={handleShow}> ADD</Button>
                        </Grid>
                        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                            <TableContainer sx={{ maxHeight: 440 }}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            {columns.map((column) => (
                                                <TableCell
                                                    key={column.id}
                                                    align={column.align}
                                                    style={{ minWidth: column.minWidth }}
                                                    className={style.labtablebg}
                                                >
                                                    <Typography><b>{column.label}</b></Typography>
                                                </TableCell>
                                            ))}
                                            <TableCell
                                                key={'action'}
                                                className={style.labtablebg}>
                                                <Typography><b>Action</b></Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                        {tableData?.map((row: any, index: number) => {
                                            return (
                                                <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                                    {columns.map((column) => {
                                                        const value: any = row[column.id];
                                                        return (
                                                            <TableCell
                                                                key={column.id}
                                                                align={column.align}>
                                                                {column.format && typeof value === 'number'
                                                                    ? column.format(value)
                                                                    : value}
                                                            </TableCell>

                                                        );
                                                    })}
                                                    <TableCell key={"action"} >
                                                        <FlexDiv>
                                                            <Typography sx={{ marginLeft: "10px" }}>
                                                                <Tooltip title="Edit">
                                                                    <Button className={style.buttonadj} variant="outlined" value="edit" color='primary' size="small" onClick={() => Edithandle(row, id)} >Edit</Button>
                                                                </Tooltip>
                                                                <Tooltip title="Delete" sx={{ marginLeft: "5px"}}>
                                                                    <Button className={style.buttonadj} variant="outlined" value="delete" color='error' size="small" onClick={() => handleDelete(index)}>Delete</Button>

                                                                </Tooltip>
                                                            </Typography>
                                                        </FlexDiv>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                        {
                                            !tableData?.length ?
                                                <TableCell align='center' colSpan={columns.length + 1}>
                                                    No Records Found
                                                </TableCell> : null
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ display: "flex", justifyContent: "end", marginTop: '10px' }}>
                            <Box component='div'
                                sx={buttonStyle}
                            >
                                <Box component='span' mr={2}>
                                    <CMLinkButton variant="contained" color="secondary" value="Cancel" link={PageRoutes.PATIENT_LIST} />
                                </Box>
                                <Box component='span'>
                                    <CMButton variant="contained" value="Submit" color="primary" type="submit"></CMButton>
                                </Box>
                            </Box>
                        </Grid>

                    </Grid>
                </Grid>
            </form>
            {openModal && <PatientModel show={openModal} onHide={handleClose} header="Add Patient Details" onAddRow={handleAddRow} />}
            {openEditModal && <PatientModel show={openEditModal} onHide={handleCloseedit} edit={handleedit} header="Update Patient Details" rowData={SelectedRowData} />}
        </>
    );
}

export default PatientTable;